import { render, staticRenderFns } from "./Manage-Location.vue?vue&type=template&id=6e28b9aa&"
import script from "./Manage-Location.vue?vue&type=script&lang=js&"
export * from "./Manage-Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports